import React, { useState } from 'react'
import styled from 'styled-components'
import SetupButton from '../DropdownPriceAlerts/components/SetupButton'
import useTranslation from 'hooks/useTranslation'
import { ReactComponent as ApplePayIcon } from './svg/apple-pay.svg'
import { ReactComponent as GooglePayIcon } from './svg/google-pay.svg'
import { ReactComponent as MasterCardIcon } from './svg/master-card.svg'
import { ReactComponent as PayPalIcon } from './svg/payPal.svg'
import { ReactComponent as VisaIcon } from './svg/visa.svg'
import useLocale from 'hooks/useLocale'

const DropdownFooter = () => {
  const [isActive, setIsActive] = useState(false)
  const { t } = useTranslation()
  const { locale } = useLocale()
  const paymentsLink = locale === 'en' ? '/page/buy-crypto?coin=btc' : `/page/${locale}/buy-crypto?coin=btc`

  return (
    <DropdownFooterWrapper onMouseEnter={() => setIsActive(true)} onMouseLeave={() => setIsActive(false)}>
      <MasterCardIcon />
      <VisaIcon />
      <GooglePayIcon />
      {!isActive && (
        <>
          <ApplePayIcon />
          <PayPalIcon />
        </>
      )}
      {isActive && (
        <SetupButton withLocale={false} notBorder href={paymentsLink} label={t('See All Payment Methods')} />
      )}
    </DropdownFooterWrapper>
  )
}

export default DropdownFooter

const DropdownFooterWrapper = styled.div`
  padding: 1.875rem 2.75rem;
  padding-right: 2rem;

  display: flex;
  align-items: center;
  border-radius: 0 0 0 8px;

  gap: 30px;
  background-color: #ffffff;

  grid-area: footer;
`
